import React from "react";
import { Link } from "react-router-dom";

import { PROVIDER } from "../brand";
import { VERSION_LABEL } from "../version";

/**
 * One line, plus the two legal links.
 *
 * This used to be three columns of scaffolding — "Contact Us / Privacy Policy / Terms of
 * Use" and a "Training Resources" list, every one of them a `<List.Item as="a">` with no
 * href — which is why it sat commented out in Layout.js rather than being deleted. Dead
 * links in front of Apple's staff are worse than no footer, so the columns went. The two
 * that came back point at real routes (`/terms`, `/privacy`), which is the condition the
 * old comment set. Add a link here only when it goes somewhere.
 */
const Footer = () => (
  <footer
    style={{
      // Kept short on purpose. 34 components size themselves to `calc(100vh - 50px)` —
      // the navbar spacer only — so anything below them adds exactly its own height to
      // the scroll on a full-height page. Teaching all 34 about a footer is not worth a
      // strapline; keeping it to ~40px makes the difference a nudge rather than a jump.
      padding: "14px 0 12px",
      textAlign: "center",
      fontSize: "11px",
      color: "#86868b",
      letterSpacing: "0.3px",
    }}
  >
    <Link to="/terms" style={{ color: "#86868b" }}>이용약관</Link>
    <span style={{ margin: "0 8px", opacity: 0.5 }}>·</span>
    <Link to="/privacy" style={{ color: "#86868b" }}>개인정보처리방침</Link>
    <span style={{ margin: "0 8px", opacity: 0.5 }}>·</span>
    {PROVIDER}
    <span style={{ margin: "0 8px", opacity: 0.5 }}>·</span>
    {/* Dimmer than the rest: useful when a tester reports a bug, noise the other 99%
        of the time. Not a link — there is nothing at the other end for a trainee. */}
    <span style={{ opacity: 0.65 }}>{VERSION_LABEL}</span>
  </footer>
);

export default Footer;
